/* eslint-disable no-case-declarations */
import {
  FETCH_CONFIG_REQUEST,
  FETCH_CONFIG_SUCCESS,
  FETCH_CONFIG_FAILURE,
  CONFIG_UPDATE_REFERRAL_TYPE_FIELD,
} from '../../constants/ActionTypes';

const config = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_CONFIG_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_CONFIG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_CONFIG_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CONFIG_UPDATE_REFERRAL_TYPE_FIELD:
      const { id, fieldName, value } = action.data;
      let { referralTypes = [] } = state.data.data;

      referralTypes = referralTypes.map((rf) => {
        if (rf.id !== id) {
          return rf;
        }

        if (
          fieldName === 'value' ||
          fieldName === 'mode' ||
          fieldName === 'type'
        ) {
          rf.award[fieldName] = value;
        } else {
          rf[fieldName] = value;
        }

        return rf;
      });

      state.data.data.referralTypes = referralTypes;

      return state;
    default:
      return state;
  }
};

export default config;
